import libphonenumber from "google-libphonenumber";

const phoneUtil = libphonenumber.PhoneNumberUtil.getInstance();
const invalidPhoneMessage = "Enter a valid phone number with country code (e.g. +41 44 668 18 00)";

export function validatePhoneNumber(value, required = false) {
  const phone = String(value ?? "").trim();

  if (phone === "") return !required || "This field is required";
  if (!phone.startsWith("+")) return invalidPhoneMessage;

  try {
    return phoneUtil.isValidNumber(phoneUtil.parse(phone)) || invalidPhoneMessage;
  } catch {
    return invalidPhoneMessage;
  }
}
